import styled from 'styled-components';

import { Color, Breakpoint } from '../../enums';
import { StyledComponent } from '../../interfaces';

export const Container: StyledComponent<'div'> = styled.div``;

export const SearchInputContainer: StyledComponent<'div'> = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Input: StyledComponent<'input'> = styled.input`
  height: 62px;
  width: 100%;
  border-bottom: 1px solid ${Color.Gray300};
  font-weight: ${Color.Black};
  font-size: 30px;
  line-height: 38px;
  letter-spacing: -0.01em;
  transition: .3s;

  ::placeholder { 
    color: ${Color.Gray500};
  }

  :hover {
    border-bottom: 1px solid ${Color.Gray500};
  }

  :focus {
    border-bottom: 1px solid ${Color.Error500};
  }
`;

export const InputLabel: StyledComponent<'div'> = styled.div`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  line-height: 18px;
  color: ${Color.Gray500};

  @media ${Breakpoint.Mobile} {
    position: static;
    margin-top: 8px;
    transform: none;
  }
`;
